import { render, staticRenderFns } from "./BusinessParamsConfig.vue?vue&type=template&id=4a8a6ecb&scoped=true"
import script from "./BusinessParamsConfig.vue?vue&type=script&lang=js"
export * from "./BusinessParamsConfig.vue?vue&type=script&lang=js"
import style0 from "./BusinessParamsConfig.vue?vue&type=style&index=0&id=4a8a6ecb&prod&scoped=true&lang=css"
import style1 from "./BusinessParamsConfig.vue?vue&type=style&index=1&id=4a8a6ecb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a6ecb",
  null
  
)

export default component.exports